import React, { useEffect } from 'react';
import { CONTACT } from '../lib/constants';
import { FAQS } from '../data/faqs';
export function SeoHead() {
  useEffect(() => {
    document.title = 'Managed IT for Professional Firms | Free IT Review | CT Group';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'ISO 27001 and ISO 9001 certified managed IT, security, private hosting and voice for Australian law and accounting firms. Request a free Independent IT Review.';
    const organization = {
      '@context': 'https://schema.org',
      '@type': ['Organization', 'ProfessionalService'],
      name: 'CT Group',
      url: 'https://ctgroup.com.au/',
      logo: 'https://cdn.magicpatterns.com/uploads/sZo6ofHHH3UDxg1SosgSFv/CTGroup_Logo.svg',
      description: 'Managed IT, security, private hosting, voice, AI adoption and ISO readiness for Australian professional services firms.',
      telephone: CONTACT.phone,
      areaServed: ['Perth', 'Melbourne', 'Sydney', 'Brisbane', 'Adelaide', 'Australia'],
      knowsAbout: ['Managed IT services', 'Cybersecurity', 'Private cloud hosting', 'Business continuity', 'Microsoft 365', 'Legal technology', 'Accounting technology', 'AI governance', 'ISO readiness'],
      employee: [{
        '@type': 'Person',
        name: CONTACT.ceo,
        jobTitle: 'CEO'
      }, {
        '@type': 'Person',
        name: CONTACT.growthName,
        jobTitle: 'Head of Growth'
      }]
    };
    const faq = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQS.map(({
        question,
        answer
      }) => ({
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer
        }
      }))
    };
    const inject = (id: string, data: object) => {
      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(data);
    };
    inject('ld-org', organization);
    inject('ld-faq', faq);
  }, []);
  return null;
}